/**
 * Real time prescreen workflow
 */

import { useCallback } from 'react';
import { Step, Workflow } from './Workflow';
import useFeature from 'hooks/useFeature';
import { selectTenant, FeatureGroups } from 'state/tenant';
import { useSelector } from 'react-redux';
import useResponsiveQuery from 'hooks/useResponsiveQuery';
import { selectVirtualLookupSuccessful } from 'state/prescreen';
import useQueryParameters from 'hooks/useQueryParameters';

const usePrescreenWorkflow = () => {
  const tenant = useSelector(selectTenant);
  const { isGroupEnabled } = useFeature();
  const { isMobile } = useResponsiveQuery();
  const virtualLookupSuccessful = useSelector(selectVirtualLookupSuccessful);
  const { selectedCardKey } = useQueryParameters();
  const { isEnabled } = useFeature();

  const getWorkflow = useCallback((): Workflow => {
    return {
      stepsEnabled: {
        [Step.PRESCREEN_OFFER]: true,

        [Step.CARD_SELECTOR]: isEnabled('cardSelector') && !selectedCardKey,

        [Step.CARD_CHOICE]: tenant.enabledFeatures.cardChoices.length > 0,

        [Step.CONSUMER_SEARCH]: !virtualLookupSuccessful,

        [Step.APPLICATION]: true,

        [Step.APPLICATION_2]: isMobile,

        [Step.ADD_ONS]: isGroupEnabled(FeatureGroups['add-ons']),

        [Step.REVIEW_TERMS]: true,
      },
      paths: {
        [Step.PRESCREEN_OFFER]: '/prescreen/offer',
        [Step.CARD_SELECTOR]: '/card-selector',
        [Step.CARD_CHOICE]: '/card-choice',
        [Step.CONSUMER_SEARCH]: '/consumer-search',
        [Step.APPLICATION]: '/prescreen/application',
        [Step.APPLICATION_2]: '/prescreen/application/2',
        [Step.ADD_ONS]: '/add-ons',
        [Step.REVIEW_TERMS]: '/prescreen/review-terms',
      },
      progressStartStep: Step.APPLICATION,
      restartStep: Step.PRESCREEN_OFFER,
      timeoutRestartPath: '/',
    };
  }, [
    isEnabled,
    selectedCardKey,
    tenant.enabledFeatures.cardChoices.length,
    virtualLookupSuccessful,
    isMobile,
    isGroupEnabled,
  ]);
  return getWorkflow;
};

export default usePrescreenWorkflow;
